import React, { FC } from "react";
import { ContactsView } from "../components";

export const SpamContactsPage: FC = () => {
  return <ContactsView isSpam />;
};
